export function findTopmostDialog(): HTMLElement | null {
  const zIndexOf = (element: HTMLElement): number => Number(element.style.zIndex) || 0;
  const dialogs = Array.from(document.querySelectorAll<HTMLElement>('.p-dialog'));
  return dialogs.reduce<HTMLElement | null>((topmost: HTMLElement | null, dialog: HTMLElement) =>
    topmost === null || zIndexOf(dialog) >= zIndexOf(topmost) ? dialog : topmost, null);
}
